/**
 * @generated SignedSource<<2db34987a548c8f5d6bf22bbc3f1cab0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type linkToolsGetURLIsOkQuery$variables = {
  url: string;
};
export type linkToolsGetURLIsOkQuery$data = {
  readonly getUrlIsOk: {
    readonly isOk: boolean;
  } | null;
};
export type linkToolsGetURLIsOkQuery = {
  response: linkToolsGetURLIsOkQuery$data;
  variables: linkToolsGetURLIsOkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "url"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "url",
        "variableName": "url"
      }
    ],
    "concreteType": "CheckURLStatusNode",
    "kind": "LinkedField",
    "name": "getUrlIsOk",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isOk",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "linkToolsGetURLIsOkQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "linkToolsGetURLIsOkQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "03b87947aafcaa2c4e0eba391b7f39f3",
    "id": null,
    "metadata": {},
    "name": "linkToolsGetURLIsOkQuery",
    "operationKind": "query",
    "text": "query linkToolsGetURLIsOkQuery(\n  $url: String!\n) {\n  getUrlIsOk(url: $url) {\n    isOk\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9c4a93c8efa0da5e79d7f24f332734b";

export default node;
